export default name => {
  name = name.toUpperCase()
  const UPDATED = `${name}_UPDATED`
  const FETCH_STARTED = `FETCH_${name}_STARTED`
  const FETCH_FINISHED = `FETCH_${name}_FINISHED`
  const FETCH_FAILED = `FETCH_${name}_FAILED`

  return (state = {}, { type, payload }) => {
    if (type === UPDATED || type === FETCH_FINISHED) {
      return Object.assign({}, state, payload, {
        loading: false,
        error: null
      })
    }
    if (type === FETCH_STARTED) {
      return Object.assign({}, state, {
        loading: true,
        error: null
      })
    }
    if (type === FETCH_FAILED) {
      return Object.assign({}, state, {
        loading: false,
        error: Date.now()
      })
    }
    return state
  }
}
